import React from "react";
import styles from "./styles.module.less";

const { avatar, content, labelTag } = styles;

interface IWProps {
  Icon: any;
  label: string;
  Text: any;
  handleClick?: () => void;
}

const Widget: React.FC<IWProps> = (props) => {
  const { Icon, Text, handleClick, label } = props;
  return (
    <div>
      <div onClick={handleClick} className={avatar}>
        {Icon}
      </div>
      <div className={labelTag}>{label}</div>
      <div className={content}>{Text}</div>
    </div>
  );
};

export default Widget;
